import * as React from "react";
const SvgFiRrFrog = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-frog_svg__a)">
      <path
        fill="#062147"
        d="M22.81 9.08a3.16 3.16 0 0 0 1.183-2.676 3.22 3.22 0 0 0-1.547-2.546c-.772-.466-1.946-.892-3.574-1.297A3.506 3.506 0 0 0 15.5-.001c-1.493 0-2.77.94-3.272 2.259C3.12 6.628.56 12.888.025 17.398a5.85 5.85 0 0 0 1.448 4.567A6.06 6.06 0 0 0 6 24h9a1 1 0 0 0 0-2h-2v-3c0-1.428.193-3.121.398-4.513l5.464 8.587c.369.579 1 .925 1.687.925h1.45a1 1 0 0 0 0-2h-1.45l-6.342-9.966a1.1 1.1 0 0 1 .383-.108c3.276-.294 6.349-1.357 8.22-2.845M15.5 2c.827 0 1.5.673 1.5 1.5S16.327 5 15.5 5 14 4.327 14 3.5 14.673 2 15.5 2m-3.783 10.367a57 57 0 0 0-.426 2.745A6.49 6.49 0 0 0 6.5 13H6a1 1 0 0 0 0 2h.5c2.48 0 4.5 2.019 4.5 4.5V22H6a4.06 4.06 0 0 1-3.032-1.363 3.8 3.8 0 0 1-.957-3.003c.647-5.452 4.145-9.959 10.144-13.101A3.51 3.51 0 0 0 15.499 7a3.51 3.51 0 0 0 3.319-2.387c1.19.315 2.06.636 2.594.958.346.209.56.56.585.962.025.386-.133.744-.433.982-1.857 1.477-4.913 2.218-7.154 2.419-1.351.122-2.46 1.123-2.694 2.433"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-frog_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFrog;
